import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackService} from '../../services/snack.service';
import {FormControl, Validators} from '@angular/forms';
import {Product} from '../../model/Entities/Product';
import {numberValidator} from '../../validators/number.validator';
import {ProductService} from '../../services/product.service';
import {ProductType} from '../../model/Entities/ProductType';
import {Observable} from 'rxjs/Observable';
import {Filter} from '../../model/Helpers/Filter';
import {ProductContent} from '../../model/Entities/ProductContent';
import {ProductContentService} from '../../services/product-content.service';
import {VatRateService} from '../../services/vat-rate.service';
import {ProductCategory} from '../../model/Entities/ProductCategory';
import {ProductCategoryService} from '../../services/product-category.service';
import {Subject} from 'rxjs/Subject';
import {debounceTime, distinctUntilChanged, map, switchMap} from 'rxjs/operators';
import {ContractItemType} from '../../model/Entities/ContractItemType';
import {environment} from '../../environments/environment';

@Component({
    selector: 'product-edit',
    templateUrl: './product-edit.component.html',
    styleUrls: ['./product-edit.component.scss']
})
export class ProductEditComponent implements OnInit {
    readonly productTypeClass: any = ProductType;

    product: Product = new Product();
    categories: ProductCategory[] = [];
    editing = false;

    private productSearchValue: string;
    private productSearchRunning = false;
    private searchedProducts: Product[] = [];
    private productSearch: ElementRef;

    private searchSubject: Subject<any> = new Subject();

    // lazy setter, when *ngIf becomes true
    // @ViewChild('productSearch') set content(content: ElementRef) {
    //     this.productSearch = content;
    //
    //     if (!this.productSearch) {
    //         return;
    //     }
    //
    //     let subscr = Observable.fromEvent(this.productSearch.nativeElement, 'keyup')
    //         .debounceTime(500)
    //         .distinctUntilChanged().subscribe((e) => {
    //
    //             subscr.unsubscribe();
    //
    //             const subproductsIds = [];
    //             for (let i = 0; i < this.product.content.length; i++) {
    //                 subproductsIds.push(this.product.content[i].contentId);
    //             }
    //
    //             this.productService.getPaginatedList(null, null, [
    //                 new Filter('name', '*' + this.productSearch.nativeElement.value.trim() + '*'),
    //                 new Filter('type', ProductType.group, '<>'),
    //                 new Filter('id', subproductsIds, '<>')
    //             ]).subscribe((data: Product[]) => {
    //                 this.searchedProducts = data;
    //             });
    //
    //         });
    // }


    nameFC = new FormControl('', [
        Validators.required,
    ]);

    codeFC = new FormControl('', [
        Validators.required,
    ]);

    priceFC = new FormControl('', [
        Validators.required,
        Validators.min(0),
        numberValidator()
    ]);

    lossPriceFC = new FormControl('', [
        Validators.required,
        Validators.min(0),
        numberValidator()
    ]);

    storeDelayFC = new FormControl('', [
        Validators.required,
        Validators.min(0),
        numberValidator()
    ]);

    packagedIn = new FormControl('', []);
    stockCountFC = new FormControl('', [
        Validators.required,
        Validators.min(0),
        numberValidator()
    ]);

    packageCountFC = new FormControl('', [
        Validators.required,
        // Validators.min(1),
        numberValidator()
    ]);

    eshopTitle = new FormControl('', [
    ]);

    eshopName = new FormControl('', [

    ]);

    eshopVisible = new FormControl('', [
    ]);

    eshopDescription = new FormControl('', [
    ]);


    constructor(private route: ActivatedRoute,
                private router: Router,
                private productService: ProductService,
                private productCategoryService: ProductCategoryService,
                private productContentService: ProductContentService,
                public vatRateService: VatRateService,
                private snackService: SnackService,
                private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.loadProductCategories();
        const id = +this.route.snapshot.paramMap.get('id');
        if (id !== 0) {
            this.editing = true;
            this.loadProduct(id);
        } else {
        }


        this.searchSubject
            .pipe(
                debounceTime(500),
                distinctUntilChanged(),
                map(e => {
                    const subproductsIds = [];
                    for (let i = 0; i < this.product.content.length; i++) {
                        subproductsIds.push(this.product.content[i].contentId);
                    }

                    return [
                        new Filter('name', '*' + e.target.value.trim() + '*'),
                        new Filter('type', ProductType.group, '<>'),
                        new Filter('id', subproductsIds, '<>')
                    ];
                }),
                switchMap(f => this.productService.getPaginatedList(null, null, f))
            )
            .subscribe(data => {
                this.searchedProducts = data;
            });
    }

    log(t): void {
        console.log(t);
    }

    save(): void {
        if (this.product.type === ProductType.group) {
            this.product.lossPrice = 0;
            this.product.storeDelay = 0;
            this.product.count = 0;

            if (!this.product.isOverridenPrice) {
                this.product.hirePrice = 0;
            }
        }

        if (this.editing) {
            this.productService.update(this.product.id, this.product).subscribe(() => {
                this.router.navigate([`/product/${this.product.id}`]);
                this.snackService.showSuccess(`Inventář ${this.product.name} byl upraven`);
            });
        } else {
            this.productService.save(this.product).subscribe((product: Product) => {

                if (this.product.type === ProductType.group) {
                    this.product.id = product.id;
                    this.editing = true;

                    this.product.content.forEach((c: ProductContent) => {
                        c.setProduct(this.product);
                        this.saveProductContent(c);
                    });
                }

                this.router.navigate([`/product/${product.id}`]);
                this.snackService.showSuccess(`Inventář ${this.product.name} byl vytvořen`);
            });
        }
    }

    checkValidity(): boolean {
        // console.log('VAL', this.packageCountFC.valid);
        return this.nameFC.valid
            && this.codeFC.valid
            && (
                (this.product.type === ProductType.group && !this.product.isOverridenPrice)
                || (this.product.type === ProductType.group && this.priceFC.valid)
                || (
                    this.priceFC.valid
                    && this.lossPriceFC.valid
                    && this.storeDelayFC.valid
                    && this.packageCountFC.valid
                    // && this.stockCountFC.valid
                )
            );
    }

    private addProductToGroup(p: Product) {
        const c: ProductContent = new ProductContent();

        c.setProduct(this.product);
        c.setContent(p);
        c.count = 1;

        this.product.content.push(c);

        this.searchedProducts = [];

        if (this.editing) {
            this.productContentService.save(c).subscribe((newC: ProductContent) => {
                c.id = newC.id;
                this.snackService.showSuccess(`Inventář ${c.getContent().name} byl přidán do skupiny`);
            });
        }
    }

    private deleteProductFromGroup(c: ProductContent) {
        this.product.content.splice(
            this.product.content.indexOf(c),
            1
        );

        if (!this.editing) {
            return;
        }

        this.productContentService.delete(c.id).subscribe(() => {
            this.snackService.showSuccess(`Inventář ${(c as ProductContent).getContent().name} byl odebrán ze skupiny`);
        });
    }

    private changeProductInGroupCount(c: ProductContent) {
        // console.log('changed', c.getContent().name, c.count);

        if (!this.editing) {
            return;
        }

        this.productContentService.update(c.id, c).subscribe(() => {
            this.snackService.showSuccess(`Počet inventáře ${c.getContent().name} ve skupině byl nastaven na ${c.count} ks`);
        });
    }

    private saveProductContent(c: ProductContent) {
        this.productContentService.save(c).subscribe(() => {
        });
    }

    private loadProduct(id: Number): void {

        this.productService.get(id, {expand: 'count'}).subscribe((product: Product) => {

            this.product = product;
            // this.cdr.detectChanges();

            this.loadProductContent();
        });
    }

    private loadProductContent(): void {
        this.productContentService.getSimpleList([
            new Filter('product_id', this.product.id)
        ], {expand: 'content'})
            .subscribe((contents: ProductContent[]) => {
                contents.forEach((c: ProductContent) => {
                    // let x = Object.assign(new ProductContent(), c);
                    // console.log('PRODUCTCONTENT', typeof x, x.constructor.name);
                    this.product.content.push(c);
                });
                // this.cdr.detectChanges();
            });
    }

    loadProductCategories(): void {
        this.productCategoryService.getSimpleList().subscribe((cats: ProductCategory[]) => {
            this.categories = cats;
        });
    }

    protected readonly contractItemTypeClass = ContractItemType;

    showEshopProduct() {
        const url = environment.eshopAdmin + '/#/products/' + this.product.eshopExportId;
        window.open(url, "_blank");
    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductEditComponent/product-edit.component.ts